import { CloseWasteContainerDto, WasteContainerDto } from '@services/dtos'
import { useAppDispatch } from '@hooks/reduxHooks'
import { disposeWasteContainer } from '@state/reducers/wasteContainerReducer'
import { WasteContainerMeasurementDialog } from './WasteContainerMeasurementDialog'

type Props = {
  open: boolean
  container: WasteContainerDto
  onClose: () => void
}

export function DisposeWasteContainerDialog({ open, container, onClose }: Props) {
  const dispatch = useAppDispatch()

  const handleSubmit = (dto: CloseWasteContainerDto) =>
    dispatch(disposeWasteContainer({ id: container.id, dto })).unwrap()

  return (
    <WasteContainerMeasurementDialog
      open={open}
      container={container}
      onClose={onClose}
      title={`Éliminer le conteneur #${container.no}`}
      successMessage="Conteneur éliminé avec succès"
      errorMessage="Une erreur est survenue lors de l'élimination"
      onSubmit={handleSubmit}
    />
  )
}
